import Tooltip from 'primevue/tooltip'
import { defineNuxtPlugin } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  // The Vue-version type mismatch this used to need a @ts-expect-error for is
  // gone; TS now reports the directive as unused.
  nuxtApp.vueApp.directive('tooltip', Tooltip)
})
